export default __webpack_public_path__ + "static/media/Whole Life Insurrance.10590767.png";